import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, useTheme } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ViewerLink from './ViewerLink';
import { getViewerUrl } from '../routing/sectionUrl';

/**
 * Button for navigating back to the Landing page using the provided URL.
 * @param {object} props Props accepted by the component.
 * @param {string} props.testID Test ID to be used.
 * @param {string} props.homeURL When the button is clicked, navigate to this URL.
 * @returns {React.FunctionComponent} React element that contains the back button.
 */
function BackButton({ testID, homeURL }) {
  const { palette } = useTheme();

  const [translate, i18n] = useTranslation();
  const internalHomeURL = homeURL || `/?lang=${i18n.language}`;

  return (
    <ViewerLink
      id={testID}
      to={internalHomeURL}
      href={getViewerUrl({ language: i18n.language })}
      style={{
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        color: palette.text.secondary,
      }}
    >
      <ArrowBackIosIcon
        fontSize="12px"
        htmlColor="inherit"
        style={{ verticalAlign: 'middle' }}
      />
      <Typography id={`${testID}Text`} variant="body_xs" component="span">
        {translate('back')}
      </Typography>
    </ViewerLink>
  );
}

export default BackButton;
